module.exports = __webpack_public_path__ + "static/media/profile-active.1b3b57da.svg";